import React, { useEffect } from "react";
import UserPage from "../../common/UserPage/UserPage";
import Footer from "../../common/Footer/Footer";
import TherapistTherapyPlanner from "../../components/TherapistTherapyPlanner/TherapistTherapyPlanner";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentTherapist } from "../../redux/therapistSlice";

function TherapistTherapyPlannerPage() {
  const dispatch = useDispatch();

  const therapistState = useSelector((state) => state.therapist) || {};
  const { therapist } = therapistState;

  useEffect(() => {
    dispatch(getCurrentTherapist());
  }, [dispatch]);

  return (
    <div>
      <UserPage customImage={therapist?.picture} />
      <TherapistTherapyPlanner />
      <Footer />
    </div>
  );
}

export default TherapistTherapyPlannerPage;
